export default "__VITE_ASSET__9cd32433__"